import firebase from "firebase";
import "firebase/firestore";
import "firebase/messaging";
import "firebase/auth";

const config = {
  apiKey: "AIzaSyCGimmfzw2Ikqa5neGDKdGUI0B1KWyXg5U",
  authDomain: "vanapp-5bcd8.firebaseapp.com",
  databaseURL: "https://vanapp-5bcd8.firebaseio.com",
  projectId: "vanapp-5bcd8",
  storageBucket: "vanapp-5bcd8.appspot.com",
  messagingSenderId: "392697762489",
};

firebase.initializeApp(config);

// Initialize Cloud Firestore through Firebase
let db = firebase.firestore();
let auth = firebase.auth();
let field = firebase.firestore.FieldValue;
let docid = firebase.firestore.FieldPath;
let store = firebase.storage();
let rtdb = firebase.database();
//export default { db, auth }

//Initialize Second Cloud Firestore for user creation
var otherApp = firebase.initializeApp(config, "other");
var otherdb = otherApp.firestore();
var otherauth = otherApp.auth();

export default { db, auth, otherdb, otherauth, field, docid, store, rtdb };

firebase.initialize;
//enable Online Persistence
/** firebase.firestore().enablePersistence().catch(err => {
    if (err.code == 'failed-precondition') {
        alert("Multiple tabs opened...try only have one tab opened.")
    } else if (err.code == 'unimplemented') {
        alert("Curent Browser does not support Offline features.")
    }
})*/

db.enablePersistence({ experimentalTabSynchronization: true }).then(() => {});
